import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../assets/arrow-left.svg";
import { ReactComponent as MenuIcon } from "../../assets/menu-mobile.svg";
import Logo from "../../authentication/components/Logo";
import { useCustomisation } from "../../context/CustomisationContext";

interface NavMobileProps {
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  title?: string;
}

export const NavMobile: React.FC<NavMobileProps> = ({
  setSidebarOpen,
  title,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { customisations } = useCustomisation();
  const navbarBgColor =
    customisations.customisations.GPC.navbarSettings?.navbarBgColor || undefined;
  const primaryTextColor =
    customisations?.customisations?.HOME?.textColorsSettings
      ?.homePrimaryTextColor ??
    customisations?.customisations?.GPC?.textColorsSettings
      ?.gpcPrimaryTextColor;

  const iconButtonStyles = {
    backgroundColor: "transparent",
    "@media (hover: hover)": {
      "&:hover": {
        backgroundColor: `${primaryTextColor} !important`,
      },
    },
  };

  const isHomeRoute =
    location.pathname === "/home" || location.pathname === "/";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: navbarBgColor,
        p: 1,
      }}
    >
      {isHomeRoute ? (
        <Logo isLoginPageLogo={false} />
      ) : (
        <IconButton onClick={() => navigate(-1)} sx={iconButtonStyles}>
          <BackIcon style={{ color: primaryTextColor }} />
        </IconButton>
      )}
      <Typography sx={{ color: primaryTextColor, fontWeight: 500 }}>
        {title}
      </Typography>
      <IconButton
        id="sidebar-toggle-button-mobile"
        onClick={() => setSidebarOpen((prev) => !prev)}
        sx={iconButtonStyles}
      >
        <MenuIcon style={{ color: primaryTextColor }} />
      </IconButton>
    </Box>
  );
};
